<template lang="pug">
.search-query
	form.search-query__form(@submit.prevent="executeSearch")
		label.search-query__label(for="search-input") {{ labelText }}
		input#search-input.search-query__input(
			type='text',
			v-model="queryModel",
			required
		)
		button.search-query__submit(
			type='submit',
		)
			span {{ submitBtnText }}
	h1.search-query__term-label Search results for: 
		span {{ results.queryUsed.searchTerm }}
	span.search-query__results {{ results.totalResultCount }} results found
</template>

<script>
export default {
	name: "CustomQuery",
	props: {
		results: Object,
		executeSearch: Function,
		setQuery: Function,
		query: String
	},
	data() {
		return {
			labelText: null,
			submitBtnText: null,
		}
	},
	computed: {
		queryModel: {
			get() {
				return this.query;
			},
			set(val) {
				this.setQuery(val);
			},
		},
	},
	methods: {},
	created() {
		// console.log(this.$root.options);
		this.labelText = this.$root.options.queryLabelText;
		this.submitBtnText = this.$root.options.querySubmitText;
	}
}
</script>

<style lang="scss" scoped>
.search-query {
	grid-area: head;
	&__form{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		column-gap: 1rem;
		row-gap: 0.5rem;
	}
	&__label {
		flex: 1 1 100%;
		font-size: 0.875rem;
		font-weight: 500;
		color: $altGray;
		text-transform: uppercase;
		font-family: $fontFamilyHeadings;
		font-weight: 500;
	}
	&__input {
		border-radius: 0.5rem;
		border-width: 2px;
		flex: 1;
		padding: 0.5rem 0.75rem;
		align-self: flex-start;
		line-height: 19px;
		height: 50px;
		@include mqdn(sm_dn) {
			height: 44px;
		}
	}
	&__submit {
		@include btn;
		padding-top: 9px;
		padding-bottom: 9px;
		align-self: flex-start;
		line-height: 14px;
	}
	&__term-label {
		margin: 2.5rem 0 0;
		span {
			color: $darkGray;
			font-size: inherit;
		}
	}
	&__results {
		font-size: #{$h4Size};
		margin-top: #{$gutter};
		font-family: $fontFamilyHeadings;
		font-style: none;
		padding-left: 0;
		font-weight: 500;
	}
}
</style>